import { Modal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';
import { useUIStore } from '~/store/useUIStore';
import { useSearchParams } from 'next/navigation';
import { SearchForm } from '~/components/ui/forms/SearchForm';
import { useAppStore } from '~/store/useAppStore';
import { SearchTab } from '@habity/types';

export const SearchModal = ({ tab }: { tab: SearchTab }) => {
  const modals = useUIStore((state) => state.modals);
  const setModals = useUIStore((state) => state.setModals);
  const searchParams = useSearchParams();
  const isMobile = useAppStore((state) => state.isMobile);
  const initialRef = useRef<TODO | null>(null);

  const onClose = () => {
    setModals({ ...modals, searchOpen: false });
  };

  // Handle Escape key to close modal
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && modals.searchOpen) {
        onClose();
      }
    };

    if (modals.searchOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [modals.searchOpen]);

  useEffect(() => {
    const search = searchParams?.get('search');
    if (search && search === 'true')
      return setModals({ ...modals, searchOpen: true });
  }, [searchParams]);

  return (
    <>
      <Modal
        initialFocusRef={initialRef}
        autoFocus={false}
        isOpen={modals.searchOpen}
        onClose={onClose}
        returnFocusOnClose={false}
        size="2xl"
        motionPreset={isMobile ? 'none' : 'scale'}
      >
        <ModalOverlay display="block" />
        <ModalContent
          my={{ mobile: 'auto', desktop: '4' }}
          rounded="4px"
          overflow="hidden"
        >
          <SearchForm tab={tab} onClose={onClose} hidePersonas />
        </ModalContent>
      </Modal>
    </>
  );
};
